module.exports = __webpack_public_path__ + "static/media/logo.65acf18d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 610
 ** module chunks = 0
 **/